module.exports = __webpack_public_path__ + "ceaa489ba57f1f96d2e8225bde37b7e4.svg";